export const investorsImage = [
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/Sequoia_Capital_-_png_0.png?updatedAt=1685422955859",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/logo_1.png?updatedAt=1685423014301",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/Google_-_png_0.png?updatedAt=1685423063995",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/AngelList_Venture_-_png_0.png?updatedAt=1685423104345",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/Wellfound_-_png_0__1_.png?updatedAt=1685423349281",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/About-us/Wellfound_-_png_1__1_.png?updatedAt=1685423469853",
  },
  {
    image:
      "https://img.learntube.ai/public-assets/Learntube/images%20(30).webp",
  },
];

export const angelInvestors = [
  {
    id: 1,
    first_name: "Jitendra",
    last_name: "Gupta",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203.png?updatedAt=1685423579201",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/PayU_India_-_jpeg_0.png?updatedAt=1685423564870",
    designation: "Founder",
  },
  {
    id: 2,
    first_name: "Ravi",
    last_name: "Garikipati",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_52.png?updatedAt=1685423721302",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0.png?updatedAt=1685423777121",
    designation: "Ex CTO",
  },
  {
    id: 3,
    first_name: "Ravijot",
    last_name: "Chugh",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle.png?updatedAt=1685423855358",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/upGrad_-_jpeg_0.png?updatedAt=1685423867426",
    designation: "Co-founder",
  },
  {
    id: 4,
    first_name: "Kaushik",
    last_name: "Subramanian",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_520323456.png?updatedAt=1685423959561",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Facebook_-_png_0.png?updatedAt=1685424009735",
    designation: "Ex Product Head",
  },
  {
    id: 5,
    first_name: "Dr. Ajay",
    last_name: "Prabhu",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203__1_.png?updatedAt=1685424114972",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Quest_Global_-_jpeg_0.png?updatedAt=1685424183434",
    designation: "COO",
  },
  {
    id: 6,
    first_name: "Harish",
    last_name: "Doraiswamy",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203__2_.png?updatedAt=1685424233029",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Pearson_-_png_0.png?updatedAt=1685424273291",
    designation: "Ex India Head",
  },
  {
    id: 7,
    first_name: "Rohit",
    last_name: "Chaddha",
    image:
      "https://img.learntube.ai/public-assets/About-us/rohit_chadha.png?updatedAt=1685424401818",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkar.png?updatedAt=1685424452173",
    designation: "COO",
  },
  {
    id: 8,
    first_name: "Rohit",
    last_name: "Raj",
    image:
      "https://img.learntube.ai/public-assets/About-us/rohit_raj.png?updatedAt=1685424493536",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/nothing.png?updatedAt=1685424560479",
    designation: "Co-Founder",
  },
  {
    id: 9,
    first_name: "Amit",
    last_name: "Zunjarwad",
    image:
      "https://img.learntube.ai/public-assets/About-us/amit_zu.png?updatedAt=1685424609864",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0__1_.png?updatedAt=1685424641448",
    designation: "CPO",
  },
  {
    id: 10,
    first_name: "Rohit",
    last_name: "Kilam",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203__3_.png?updatedAt=1685424737660",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0__2_.png?updatedAt=1685424776063",
    designation: "CTO",
  },
  {
    id: 11,
    first_name: "Rajesh",
    last_name: "Bysani",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203__4_.png?updatedAt=1685424846485",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0__3_.png?updatedAt=1685424877977",
    designation: "CPO",
  },
  {
    id: 12,
    first_name: "Shajikumar",
    last_name: "Devakar",
    image:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_5203__5_.png?updatedAt=1685424940346",
    companyImages:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0__4_.png?updatedAt=1685424964795",
    designation: "Director",
  },
];

export const setsUsApart = [
  {
    id: 1,
    title: "Certified Learning",
    image:
      "https://img.learntube.ai/public-assets/About-us/image_263.svg?updatedAt=1685425057876",
    description:
      "Lifetime access to a verified certificate that is recognised by over 900+ companies globally.",
  },
  {
    id: 2,
    title: "Placement Support  Bootcamp",
    image:
      "https://img.learntube.ai/public-assets/About-us/image_264.svg?updatedAt=1685425103419",
    description:
      "1 Month intensive training with portfolio reviews, CV Building, & job application support.",
  },
  {
    id: 3,
    title: "Live Mock Interviews",
    image:
      "https://img.learntube.ai/public-assets/About-us/image_265.svg?updatedAt=1685425141147",
    description:
      "Get coached by experts on how to crack the toughest of interviees & get personalised feedback to impress the best.",
  },
  {
    id: 4,
    title: "Connect to 1000+ Hiring Partners",
    image:
      "https://img.learntube.ai/public-assets/About-us/image_266.svg?updatedAt=1685425205274",
    description:
      "Your Profile will be shared with the top MNCs, Startups & Agencies to get you the best job possible.",
  },
  {
    id: 5,
    title: "Expert Led Doubt Solving",
    image:
      "https://img.learntube.ai/public-assets/About-us/image_267.svg?updatedAt=1685425251754",
    description:
      "Ask a doubt & get guaranteed responses from industry experts. No more getting stuck, ever!",
  },
  {
    id: 6,
    title: "Learn on Web, App & Whatsapp",
    image:
      "https://img.learntube.ai/public-assets/About-us/Group_8114.svg?updatedAt=1685425334687",
    description:
      "Learn right inside whatsapp! Get yout lesson videos, quizzes & certificates right inside chat!",
  },
];

export const settings = {
  dots: false,
  slidesToShow: 6,
  rows: 1,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 2000,
  easing: "linear",
  cssEase: "linear",
  infinite: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 6,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        infinite: true,
        dots: false,
        arrows: false,
        swipeToSlide: true,
      },
    },
  ],
};

export const investorsSettings = {
  dots: false,
  slidesToShow: 6,
  rows: 1,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 2000,
  easing: "linear",
  cssEase: "linear",
  infinite: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        infinite: true,
        dots: false,
        arrows: false,
        swipeToSlide: true,
      },
    },
  ],
};

export const company = [
  {
    id: 1,
    name: "About Us (Founder)",
    link: "https://learntube.ai/about-us",
  },
  {
    id: 2,
    name: "Blog",
    link: "https://learntube.ai/blog/",
  },
  {
    id: 3,
    name: "Testimonials",
    link: "https://learntube.ai/pricing?type=annual#growthwall",
  },
  {
    id: 4,
    name: "Pricing",
    link: "https://learntube.ai/pricing?type=annual",
  },
  {
    id: 5,
    name: "Contact Us",
    link: "https://learntube.ai/contactus",
  },
  {
    id: 6,
    name: "Press + Investors",
    link: "https://learntube.ai/about-us",
  },
  {
    id: 7,
    name: "Career",
    link: "https://wellfound.com/company/learntube-ai/jobs",
  },
];

export const support = [
  {
    id: 1,
    name: "Privacy Policy",
    link: "https://learntube.ai/privacypolicy",
  },
  {
    id: 2,
    name: "Refund Policy",
    link: "https://learntube.ai/refundpolicy",
  },
  {
    id: 3,
    name: "Terms and Conditions",
    link: "https://learntube.ai/termsandconditions",
  },
];

export const followUs = [
  {
    id: 1,
    name: "Instagram",
    link: "https://www.instagram.com/learntube.ai/?hl=en",
  },
  {
    id: 2,
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/careerninja/mycompany/",
  },
  {
    id: 3,
    name: "Youtube",
    link: "https://www.youtube.com/channel/UCxX6KabxbGpk9Be57xMktRQ",
  },
  {
    id: 4,
    name: "Facebook",
    link: "https://www.facebook.com/CareerNinjaIndia/",
  },
];

export const Products = [
  {
    id: 1,
    name: "Webapp",
    link: "https://learntube.ai/courses",
  },
  {
    id: 2,
    name: "Bot",
    link: "https://wa.me/919160950649?text=continue%20learning",
  },
  {
    id: 3,
    name: "Extension",
    link: "https://chrome.google.com/webstore/search/learntube?hl=en-US",
  },
  {
    id: 4,
    name: "Mobile App",
    link: "https://play.google.com/store/apps/details?id=com.learntube",
  },
];

export const list = [
  {
    id: 1,
    name: "Rating",
    link: "",
  },
  {
    id: 2,
    name: "Angel List",
    link: "",
  },
  {
    id: 3,
    name: "Google Review",
    link: "",
  },
  {
    id: 4,
    name: "GSV",
    link: "",
  },
  {
    id: 5,
    name: "India Today",
    link: "",
  },
];
